module.exports = __webpack_public_path__ + "img/mobile-help-2.c028df05.jpg";